import { useCallback, useMemo, useState } from "react"
import { setPersistedViewType } from "./cookie-storage"
import type { ViewType } from "./types"

export const useViewSelector = (initialViewType: ViewType) => {
  const [viewType, setViewType] = useState<ViewType>(initialViewType)

  const persistViewType = useCallback((viewType: ViewType) => {
    setViewType(viewType)
    setPersistedViewType(viewType)
  }, [])

  return useMemo(
    () => ({ viewType, setViewType: persistViewType }),
    [viewType, persistViewType],
  )
}
